import React, { useEffect } from 'react';

import Col from 'react-bootstrap/Col';
import ListView from '../shared/lists/ListView';
import PagedListControl from '../shared/lists/PagedListControl';
import Row from 'react-bootstrap/Row';
import SortableTh from '../shared/table/SortableTh';
import DailyLeadLogItem from './DailyLeadLogItem';
import Form from 'react-bootstrap/Form';
import FormControl from '../shared/inputs/FormControl';
import SelectList from '../shared/inputs/SelectList';

const Commissions = ({
    items,
    filter,
    pageable,
    setFilter,
    setUrl,
    sort
}) => {
    const postUrl = `/reports/commission`;

    useEffect(() => setUrl(postUrl), []);

    return (
        <Row>
            <Col>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label className="col-form-label-sm">
                            From
                        </Form.Label>
                        <FormControl
                            className="form-control-sm"
                            defaultValue={filter.dateFrom}
                            name="dateFrom"
                            onChange={setFilter}
                            type="date"
                        />
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label className="col-form-label-sm">
                            To
                        </Form.Label>
                        <FormControl className="form-control-sm"
                            defaultValue={filter.dateTo}
                            name="dateTo"
                            onChange={setFilter}
                            type="date"
                        />
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label className="col-form-label-sm">
                            Designer
                        </Form.Label>
                        <SelectList className="form-control-sm"
                            lookupType="Designer"
                            name="designerId"
                            onChange={setFilter}
                            options={[{ name: 'All', id: 0 }]}
                            value={filter.designerId || 0}
                        />
                    </Form.Group>
                </Form.Row>
            </Col>
        </Row >
    );
}

export default Commissions;